import {
    MANDATORY_CREW_TOTALS_INITIAL_VALUES,
    MANDATORY_STATISTICS_INITIAL_VALUES,
    STATISTICS_PAGINATED_INITIAL_VALUES,
} from '@routes/sidebar/admin-center/___shared___/dashboards/constants.ts';
import type {
    VesselCrewMemberResponse,
    VesselStatistic,
} from '@routes/sidebar/admin-center/___shared___/dashboards/types.ts';

export const VESSEL_INITIAL_STATE: VesselStatistic = {
    vesselId: 0,
    vesselName: '',
    vesselFlag: '',
    totalCrewWithMandatoryRequirements: 0,
    statisticsSummary: {
        statistics: [],
        mandatoryStatistics: MANDATORY_STATISTICS_INITIAL_VALUES,
    },
    crewStatistics: STATISTICS_PAGINATED_INITIAL_VALUES,
    ...MANDATORY_CREW_TOTALS_INITIAL_VALUES,
};

export const VESSEL_CREW_MEMBER_INITIAL_STATE: VesselCrewMemberResponse = {
    userId: 0,
    userName: '',
    rank: '',
    lastActive: null,
    statisticsSummary: {
        statistics: [],
        mandatoryStatistics: MANDATORY_STATISTICS_INITIAL_VALUES,
    },
    crewPathwayStatistics: STATISTICS_PAGINATED_INITIAL_VALUES,
    avatarURI: '',
};
